<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-29 14:26:33
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-29 14:37:26
 * @Description: 
-->
<template>
  <div
    class="ability-card group relative flex flex-col rounded-16px border border-#ECEFF6 bg-[linear-gradient(0deg,_#FFFFFF_0%,_rgba(255,255,255,0.6)_100%)] p-24px transition-all duration-300 hover:border-primary/30 hover:shadow-[0_8px_24px_rgba(15,103,248,0.08)] lt-sm:p-24px lt-sm:rounded-16px"
  >
    <i :class="ability.icon" class="ability-card-icon wh-48px lt-sm:wh-78px"></i>
    <h3 class="ability-card-title pf-sc-semibold mt-16px font-s-18px font-semibold text-main">
      {{ ability.title }}
    </h3>
    <p
      class="ability-card-desc pf-sc-regular mt-8px flex-1 font-s-14px text-main/70 lt-sm:font-s-24px lt-sm:mt-16px"
    >
      {{ ability.desc }}
    </p>
    <NuxtLink
      class="ability-card-link mt-24px flex items-center gap-8px font-s-16px pf-sc-regular text-primary transition-colors hover:text-#0A50FF cursor-pointer lt-sm:mt-48px lt-sm:font-s-28px"
      :to="`/solutions/${ability.id}`"
      :aria-label="`查看${ability.title}详情`"
    >
      查看详情
      <i
        class="i-custom-arrow-right-c color-primary wh-18px lt-sm:wh-28px transition-transform group-hover:translate-x-4px"
        aria-hidden="true"
      ></i>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    ability: Card
  }>()
</script>

<style scoped lang="scss"></style>
